import React from "react"

import { DatePicker } from "antd"
import cls from "classname"

import Icon from "../../Icon"

import "./styles.less"

// Our date picker: antd DatePicker with the house control size (40px height, 12px
// radius, see styles.less), a registry calendar suffix icon, and the popup rendered
// into #main-layout so it is never clipped by a scrolling pane. Mirrors the Input /
// Select wrappers so date fields match every other control.
export const DatePickerComponent = React.forwardRef(
  ({ className, getPopupContainer, ...props }, ref) => (
    <DatePicker
      ref={ref || null}
      suffixIcon={<Icon type="calendar_days" style={{ pointerEvents: "none" }} />}
      getPopupContainer={
        getPopupContainer || (() => document.getElementById("main-layout") || document.body)
      }
      className={cls(className, "date-picker")}
      {...props}
    />
  )
)

export default DatePickerComponent
